export const YES_NO_QUESTION = 'yes_no';
export const TRADE_IN_VEHICLE_QUESTION = 'tradeInVehicle';
export const TEXT_QUESTION = 'text';

export const PURCHASE_REASON = 'purchaseReasons';
